import { useState, useEffect, useRef } from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import {
  StyledCustomButton,
  StyledCustomDropdown,
  StyledCustomGrid,
  StyledCustomIcon,
  StyledCustomItem,
  StyledCustomPanel,
} from './SupportDropdown.styled';
import SupportIcon from '../../../icons/SupportIcon';
import PrivacyIcon from '../../../icons/PrivacyIcon';
import DataProtectionIcon from '../../../icons/DataProtectionIcon';
import { PdfViewModal } from '../Modals';
import { colors } from '../../../theme';
import MailIcon from '../../../icons/MailIcon';
import * as privacyPolicyPDF from '../../../assets/pdfs/privacy_policy.pdf';
import * as dpaPDF from '../../../assets/pdfs/our_dpa.pdf';

const SupportDropdown = function () {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pdfFile, setPdfFile] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleMouseOut = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mouseout', handleMouseOut);
    }

    return () => {
      document.removeEventListener('mouseout', handleMouseOut);
    };
  }, [isOpen]);

  const handleLocaleSelect = (contentFor) => {
    if (contentFor === 'privacy') {
      setPdfFile(privacyPolicyPDF.default);
    }
    if (contentFor === 'data-protection') {
      setPdfFile(dpaPDF.default);
    }
    setIsModalOpen(true);
  };

  const toggleDropdown = (e) => {
    e.stopPropagation();
    setIsOpen(true);
  };

  return (
    <>
      <StyledCustomDropdown ref={dropdownRef} onMouseEnter={toggleDropdown}>
        <StyledCustomButton>
          <Flex alignItems="center" gap="8px">
            <StyledCustomIcon>
              <SupportIcon fillColor="#124684" />
            </StyledCustomIcon>
            <Text fontSize="14px" fontWeight="500">
              Support
            </Text>
          </Flex>
        </StyledCustomButton>
        {isOpen && (
          <StyledCustomPanel>
            <Box p="8px">
              <StyledCustomGrid>
                <StyledCustomItem key="privacy" onClick={() => handleLocaleSelect('privacy')}>
                  <Flex alignItems="center" gap="8px">
                    <StyledCustomIcon>
                      <PrivacyIcon fillColor={colors.main.primary} />
                    </StyledCustomIcon>
                    <Text fontSize="14px">Privacy Policy</Text>
                  </Flex>
                </StyledCustomItem>
                <StyledCustomItem
                  key="data-protection"
                  onClick={() => handleLocaleSelect('data-protection')}
                >
                  <Flex alignItems="center" gap="8px">
                    <StyledCustomIcon>
                      <DataProtectionIcon fillColor={colors.main.primary} />
                    </StyledCustomIcon>
                    <Text fontSize="14px">Our DPA</Text>
                  </Flex>
                </StyledCustomItem>
                <a
                  href="mailto:support@theclearvue.co.uk"
                  rel="noreferrer"
                  style={{ textDecoration: 'none', color: 'inherit' }}
                >
                  <StyledCustomItem key="contact_us">
                    <Flex alignItems="center" gap="8px">
                      <StyledCustomIcon>
                        <MailIcon fillColor={colors.main.primary} />
                      </StyledCustomIcon>
                      <Text fontSize="14px">support@theclearvue.co.uk</Text>
                    </Flex>
                  </StyledCustomItem>
                </a>
              </StyledCustomGrid>
            </Box>
          </StyledCustomPanel>
        )}
      </StyledCustomDropdown>
      <PdfViewModal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          setPdfFile('');
        }}
        pdfFile={pdfFile}
        toolbar={false}
        iFrameProps={{ width: '100%', height: '800rem' }}
      />
    </>
  );
};

export default SupportDropdown;
